const DrawingModes = Object.freeze({
  MOVE: 0,
  PAINTING: 1,
  EARASING: 2,
});

export default DrawingModes;
